export default __webpack_public_path__ + "static/media/氨氮.1d08aa95.png";